var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelefone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2543 12.9791V15.3877C16.256 15.8399 16.0756 16.2718 15.7573 16.5775C15.439 16.8831 15.0124 17.0342 14.5822 16.9935C12.222 16.725 9.95486 15.8808 7.96296 14.5286C6.10974 13.2959 4.53854 11.6512 3.36093 9.71134C2.06468 7.61679 1.25799 5.23206 1.00623 2.75036C0.967477 2.30145 1.11075 1.85615 1.40106 1.52325C1.69136 1.19035 2.10197 1.0005 2.53257 1.00008H4.83358C5.60355 0.992146 6.25982 1.58294 6.36759 2.38103C6.46471 3.15185 6.64482 3.9087 6.90449 4.63713C7.11521 5.22394 6.98044 5.88546 6.55934 6.33121L5.58524 7.35087C6.67712 9.36092 8.26704 11.0252 10.1873 12.1682L11.1614 11.1485C11.5872 10.7077 12.2192 10.5666 12.7797 10.7872C13.4756 11.059 14.1986 11.2476 14.935 11.3492C15.7063 11.4631 16.2736 12.164 16.2543 12.9791Z",
    stroke: "#77838F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/Telefone.1ffbf8b925108a16a762bc54b2f84dde.svg";
export { ForwardRef as ReactComponent };